<template>
  <div class="user-page full-height">
    <tableCon>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/container'}">装箱单管理</el-breadcrumb-item>
          <el-breadcrumb-item>装箱单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">用户:</div>
            <div class="query-content">{{containerInfo.userName}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">批次号:</div>
            <div class="query-content">{{containerInfo.containerBatchNo}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">箱子数:</div>
            <div class="query-content">{{containerInfo.containerBoxesCount}}</div>
          </el-col>
          <el-col :span="3" class="display-row">
            <div class="query-title">商品总实重:</div>
            <div class="query-content">{{containerInfo.totalNetWeight}}</div>
          </el-col>
          <el-col :span="3" class="display-row">
            <div class="query-title">总实重:</div>
            <div class="query-content">{{containerInfo.realWeight}}</div>
          </el-col>
          <el-col :span="3" class="display-row">
            <div class="query-title">总抛重:</div>
            <div class="query-content">{{containerInfo.throwWeight}}</div>
          </el-col>
          <!-- <el-col :span="3" class="display-row">
            <div class="query-title">总opp袋数:</div>
            <div class="query-content">{{containerInfo.oppCount}}</div>
          </el-col> -->
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">箱号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.boxNo" size="small" @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">盘点状态:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.checkStatus" placeholder="请选择" size="small" clearable>
                <el-option key="" value="" label="全部"></el-option>
                <el-option key="0" value="0" label="盘点未完成"></el-option>
                <el-option key="1" value="1" label="盘点完成"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border stripe
          style="width: 100%" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="boxNo" align="center" label="箱号"></el-table-column>
          <el-table-column prop="createTime" width="160" align="center" label="创建日期" :formatter="formatDate"></el-table-column>
          <el-table-column prop="createUserName" align="center" label="创建人"></el-table-column>
          <el-table-column prop="boxGoodsCount" align="center" label="商品数"></el-table-column>
          <el-table-column prop="realWeight" align="center" label="实重"></el-table-column>
          <el-table-column prop="throwWeight" align="center" label="抛重"></el-table-column>
          <el-table-column prop="materialName" align="center" label="箱子类型">
            <template v-slot="scope">
              {{scope.row.materialName}}<br>
              长：{{scope.row.boxLong}}<br>
              宽：{{scope.row.boxWidth}}<br>
              高：{{scope.row.boxHeight}}<br>
              除数：{{scope.row.boxDivisor}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="oppCount" align="center" label="OPP袋数"></el-table-column> -->
          <el-table-column prop="checkStatus" align="center" label="盘点状态">
            <template v-slot="scope">
              {{scope.row.checkStatus == '0' ? '盘点未完成' :'盘点完成'}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button class="list-btn-four btn-blue" @click="toOrderDetail(scope.row)">
                  详情
                </el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn-four  btn-deepblue" @click="toMoveBox(scope.row)">移箱</el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn-four btn-deepblue" @click="toMergeBox(scope.row)">合箱</el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn-four btn-deepblue" @click="handleEdit(scope.row)">编辑</el-button>
              </div>
              <div class="btn-row">
                <el-button v-if="scope.row.checkStatus == '1'" class="list-btn-four btn-gray" @click="revokeCheck(scope.row)">盘点撤回</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination> -->
      </div>
    </tableCon>

    <el-dialog title="移箱" :visible.sync="updateDialogVisible" width="30%" @close="updateDialogClose">
      <el-form :model="boxInfo" :rules="rules" ref="boxInfo" label-width="120px" class="demo-boxInfo">
        <el-form-item label="被移箱子">
          {{boxInfo.containerBatchNo}}-{{boxInfo.boxNo}}
        </el-form-item>
        <el-form-item label="目标批次" prop="targetContainerBatchNo">
          <el-select v-model="boxInfo.targetContainerBatchNo" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in containerBatchNoOptions" :key="item.containerBatchNo" :label="item.containerBatchNo"
              :value="item.containerBatchNo">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearForm" class="form-btn btn-gray">取 消</el-button>
        <el-button @click="updateSave('boxInfo')" class="form-btn btn-blue">提 交</el-button>

      </div>
    </el-dialog>
    <el-dialog title="合箱" :visible.sync="visible1" width="600px">
      <el-form :model="editInfo" :rules="rules1" ref="editInfo" label-width="120px">
        <el-form-item prop="realWeight" label="实重">
          <el-input-number v-model="editInfo.realWeight" :precision="2" :step="0.1" :min="0" :controls='false'></el-input-number>
        </el-form-item>
        <div class="throw" style="display: flex;align-items: center;">
          <div style="width: 110px;text-align: right;margin-right: 10px;">抛重</div>
          <el-form-item prop="boxLong" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxLong" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          <span class="symbol">*</span>
          <el-form-item prop="boxWidth" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxWidth" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          <span class="symbol">*</span>
          <el-form-item prop="boxHeight" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxHeight" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          <span class="symbol">/</span>
          <el-form-item prop="boxDivisor" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxDivisor" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          KG
        </div>
        <el-form-item prop="boxTypeId" style="margin-top:20px" label="箱子类型">
          <el-select v-model="editInfo.boxTypeId" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in configLists.boxConfigList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="saveEdit">确定</el-button>
        <el-button class="form-btn btn-gray" @click="visible1=false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="合箱" :visible.sync="mergeDialogVisible" width="30%" @close="updateDialogClose">
      <el-form :model="mergeBoxInfo" :rules="rules" ref="mergeBoxInfo" label-width="120px" class="demo-boxInfo">
        <el-form-item label="被合箱号">
          箱{{mergeBoxInfo.boxNo}}
        </el-form-item>
        <el-form-item label="目标批次号" prop="targetContainerBatchNo">
          <el-select v-model="mergeBoxInfo.targetContainerBatchNo" placeholder="请选择" size="small" @change="onSelectedDrug"
            clearable>
            <el-option v-for="item in containerBatchNoOptions" :key="item.containerBatchNo" :label="item.containerBatchNo"
              :value="item.containerBatchNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标箱号" prop="targetBoxNo">
          <el-select v-model="mergeBoxInfo.targetBoxNo" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in boxNoOptions" :key="item.boxNo" :label="item.boxNo" :value="item.boxNo">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearForm" class="form-btn btn-gray">取 消</el-button>
        <el-button @click="updateMergeSave('mergeBoxInfo')" class="form-btn btn-blue">提 交</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import tableCon from '../../views/tableContainer'
export default {
  data () {
    return {
      boxId: '',
      boxInfo: {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: ''
      },
      containerInfo: {
        userName: '',
        containerBatchNo: '',
        containerBoxesCount: 0,
        realWeight: 0.0,
        throwWeight: 0.0,
        oppCount: 0
      },
      editInfo: {},
      id: "",
      mergeBoxInfo: {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: '',
        targetBoxNo: '',
      },
      configLists: [],
      queryInfo: {
        containerBatchNo: '',
        boxNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 999,
        pageNum: 1,
      },
      visible1: false,
      containerBatchNoOptions: [],
      boxNoOptions: [],
      rules: {
        targetContainerBatchNo: [
          { required: true, message: '请选择目标批次', trigger: 'blur' }
        ]
      },
      orderList: [],
      total: 0,
      updateDialogVisible: false,
      mergeDialogVisible: false
    };
  },
  components: { tableCon },
  methods: {
    async revokeCheck (row) {
      console.log(row)
      this.$confirm("确定要撤回吗？",  {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const {data: res} = await this.$http.post('box/revokeCheck',{ boxNo: row.boxNo });
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "撤回成功!"
          });
          await this.getOrderList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        });
      });
    },
    formatDate (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    async getConfigLists () {
      const { data: res } = await this.$http.get(
        "order/getOrderInfoConfigList"
      );
      this.configLists = res.data;
    },
    orderDateRange () {
    },
    shipDateRange () {
    },
    queryInfoClear () {
      this.queryInfo = {
        containerBatchNo: this.queryInfo.containerBatchNo,
        boxNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 998,
        pageNum: 1,
      }
    },
    saveEdit () {
      this.$refs.editInfo.validate((valid) => {
        if (valid) {
          this.editInfo.id = this.id
          this.$http.post('box/updateBox', this.editInfo).then((res) => {
            console.log(res)
            if (res.data.code == 200) {
              this.visible1 = false
              this.getOrderList()
              this.$message.success('操作成功')
            }
          })
        }
      })
    },
    clearForm () {   //弹窗的取消按钮
      this.initForm();
      this.updateDialogVisible = false;
      this.mergeDialogVisible = false;
    },
    handleEdit (row) {
      this.editInfo = row
      this.visible1 = true
      this.id = row.id
    },
    initForm () {   //初始化弹窗的内容
      this.boxInfo = {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: ''
      };
      this.mergeBoxInfo = {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: '',
        targetBoxNo: '',
      };
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    categoryFlagChanged (row) {
      //改变状态接口 params row.No,row.categoryFlag
      console.log(row.categoryFlag);
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag;
        alert('failed')
      }, 1000);

    },
    async getOrderList () {
      const { data: res } = await this.$http.get("box/list", { params: this.queryInfo });
      this.orderList = res.data.list;
      console.log(this.orderList);
      this.total = res.data.total;
      this.total = this.orderList.length;
    },
    async getContainerInfo () {
      const { data: res } = await this.$http.get('container/getContainerInfo/' + this.queryInfo.containerBatchNo);
      this.containerInfo = res.data;
    },
    async getContainerList (boxId) {
      const { data: res } = await this.$http.get('container/getMoveContainerList/' + boxId);
      this.containerBatchNoOptions = res.data;
    },
    async getBoxList (containerBatchNo) {
      const { data: res } = await this.$http.get('box/getBoxList/' + containerBatchNo);
      this.boxNoOptions = res.data;
    },
    // 条线改变事件
    onSelectedDrug: function (val) {
      this.mergeBoxInfo.targetBoxNo = '';
      if(val){
        this.getBoxList(val);
      }else{
        this.boxNoOptions = [];
      }

    },
    toOrderDetail (row) {
      console.log(row);
      this.$router.push({
        name: 'boxOrderList',
        query: {
          boxNo: row.boxNo,
          containerBatchNo: this.queryInfo.containerBatchNo
        }
      })
    },
    toMoveBox (row) {
      this.boxInfo = {
        id: row.id,
        boxNo: row.boxNo,
        containerBatchNo: this.queryInfo.containerBatchNo,
        targetContainerBatchNo: ''
      };
      this.updateDialogVisible = true;
      this.getContainerList(this.boxInfo.id);
    },
    toMergeBox (row) {
      this.mergeBoxInfo = {
        id: row.id,
        boxNo: row.boxNo,
        containerBatchNo: this.queryInfo.containerBatchNo,
        targetContainerBatchNo: '',
        targetBoxNo: '',
      }
      this.mergeDialogVisible = true;
      this.getContainerList(this.mergeBoxInfo.id);
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getUserList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getUserList();
    },
    updateDialogClose () {    //关闭弹窗
      console.log('close');
      this.updateDialogVisible = false;
      this.mergeDialogVisible = false;
    },
    updateSave (formName) {    //保存按钮
      var my = this;
      //保存按钮
      this.$refs.boxInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          console.log(my.boxInfo)
          var url = "box/moveBox";
          const { data: res } = await my.$http.post(url, my.boxInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getOrderList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    updateMergeSave (formName) {    //保存按钮
      var my = this;
      //保存按钮
      this.$refs.mergeBoxInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          console.log(my.mergeBoxInfo)
          var url = "box/mergeBox";
          const { data: res } = await my.$http.post(url, my.mergeBoxInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getOrderList();
            my.mergeDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
  },
  watch: {
  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem('token')) {
        return false;
      }
    }
  },
  created () {
    this.queryInfo.containerBatchNo = this.$route.query.containerBatchNo;
    this.getOrderList();
    this.getContainerInfo();
    this.getConfigLists()
  },
};
</script>

<style lang="less" scoped>
.query-content {
  margin-top: 5px;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
.throw {
  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
  .symbol {
    margin: 0 15px;
  }
}
</style>
